import React, {ChangeEvent, FunctionComponent} from "react";
import {PropsWithOverwrite} from "../../../utils/input";
import Input, {InputProps} from "./Input";

type InputNumberProps = Omit<PropsWithOverwrite<InputProps<number>, {
    min?: number;
    max?: number;
}>, "type" | "onBlur">;

const InputNumber: FunctionComponent<InputNumberProps> = ({onChange, min, max, ...inputAttr}) => {
    function handleBlur(e: ChangeEvent<HTMLInputElement>) {
        let value = Number(e.target.value);
        if (max !== undefined) {
            value = Math.min(value, max);
        }
        if (min !== undefined) {
            value = Math.max(value, min);
        }
        onChange(value);
    }

    return (
        <Input
            type="number"
            onBlur={handleBlur}
            onChange={onChange}
            min={min}
            max={max}
            {...inputAttr}
        />
    );
};

export default InputNumber;
